var cifHu = ["301 151", "<g fill='none'><path fill='#CE1126' d='M.5.5h300v50H.5z'/><path fill='#FFF' d='M.5 50.5h300v50H.5z'/><path fill='#008751' d='M.5 100.5h300v50H.5z'/></g>"];

export { cifHu };

